import { render, staticRenderFns } from "./CandidateOffers.vue?vue&type=template&id=32a4795c&"
import script from "./CandidateOffers.vue?vue&type=script&lang=js&"
export * from "./CandidateOffers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Volumes/htdocs/samenaankoop/src/vue-apps/cms/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('32a4795c')) {
      api.createRecord('32a4795c', component.options)
    } else {
      api.reload('32a4795c', component.options)
    }
    module.hot.accept("./CandidateOffers.vue?vue&type=template&id=32a4795c&", function () {
      api.rerender('32a4795c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "widgets/CandidateOffers.vue"
export default component.exports